import { Box, BoxProps } from "@material-ui/core";
import React from "react";

export const TabHeader: React.FC = (props: BoxProps) => <Box display="flex" mb={2} {...props} />;
